export const PREP_CHECKLIST_COLUMN_COUNT = 3;

export function splitIntoColumns(items, columnCount = PREP_CHECKLIST_COLUMN_COUNT) {
  if (!items.length) {
    return [];
  }
  const cols = Math.min(columnCount, items.length);
  const perColumn = Math.ceil(items.length / cols);
  return Array.from({ length: cols }, (_, index) => (
    items.slice(index * perColumn, (index + 1) * perColumn)
  )).filter((column) => column.length > 0);
}
